export default __webpack_public_path__ + "static/154-807af5e366e0a30eef6171b30a0d0d21.jpg";